import { render } from "./MeetTheTeam.vue?vue&type=template&id=3f8b539a"
import script from "./MeetTheTeam.vue?vue&type=script&lang=js"
export * from "./MeetTheTeam.vue?vue&type=script&lang=js"

import "./MeetTheTeam.vue?vue&type=style&index=0&id=3f8b539a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__